import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";
import { useBudget } from "@/contexts/BudgetContext";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface StatusBadgeProps {
  onOpenSheet?: () => void;
}

export const StatusBadge = ({ onOpenSheet }: StatusBadgeProps) => {
  const { data, isLoading } = useBudget();
  const { t } = useLanguage();

  const handleClick = () => {
    if (onOpenSheet) {
      onOpenSheet();
    }
  };

  if (isLoading || !data) {
    return (
      <div className="px-3 py-1.5 rounded-full bg-muted/50 min-w-[80px] h-6 animate-pulse" />
    );
  }

  const isOnTrack = data.isOnTrack;
  const label = isOnTrack ? t('status.onTrack') : t('status.overBudget');
  const tooltipText = isOnTrack ? t('status.tooltipOnTrack') : t('status.tooltipOverBudget');

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={handleClick}
            className={cn(
              "px-3 py-1.5 rounded-full text-xs font-medium min-w-[80px] text-center flex-shrink-0 transition-colors",
              isOnTrack 
                ? "bg-primary/10 text-primary hover:bg-primary/20" 
                : "bg-amber-100 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300 hover:bg-amber-200 dark:hover:bg-amber-900/30"
            )}
          >
            {isOnTrack ? '✓' : '⚠'} {label}
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p className="text-xs">{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
